import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetTariffsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.form-default-values';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/tariffs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterSearchEmspBoTariffListContextProvider,
  useEmspBoTariffListContext,
} from '../emsp-bo-tariff.context';
import { EmspBoTariffListFilterSearchFormController } from './emsp-bo-tariff-list-filter-search-form/emsp-bo-tariff-list-filter-search-form.controller';

interface EmspBoTariffListFilterSearchControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoTariffListFilterSearchController = ({
  onCancel,
  onSuccess,
}: EmspBoTariffListFilterSearchControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoTariffListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetTariffsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-tariff-list-filter-search.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel> = (
    fieldValues,
  ) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      textToSearch: fieldValues.textToSearch,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetTariffsPaginatedDefaultValues(getPaginatedQueryParameters);

  return (
    <FilterSearchEmspBoTariffListContextProvider data={data}>
      <EmspBoTariffListFilterSearchFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterSearchEmspBoTariffListContextProvider>
  );
};
